<ap-combobox
  #combobox
  [placeholder]="filterColumn().label"
  [list]="filteredOptions()"
  [showMultipleTags]="true"
  optionName="key"
  [selectType]="optionsType"
  [disabled]="isDisabled()"
  class="w-100 d-block"
  [(ngModel)]="value"
  (ngModelChange)="updateModel()"
  (onFilterResult)="filterResultHandler($event)"
  (onClose)="closeHandler()">
  @for (item of filteredOptions(); track $index) {
    <ap-dropdown-list-item
      [item]="item"
      optionName="key"
      optionValue="value"
      [highlightText]="highlightText" />
  }
</ap-combobox>
